import React, { Component } from 'react';
import axios from 'axios';
import { authService } from '../../../utils/auth-service';

const withOrganisationData = WrapperComponent => class HasJSONAPIClient extends Component {
  constructor(props) {
    super(props);
    this.restClient = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 6000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  getOrganisationById= id => this.restClient.get(`organisations/${id}`)
    .then(response => {
      const { data: { data: { attributes } } } = response;
      return { id, ...attributes };
    });

  render() {
    return (
      <WrapperComponent
        {...this.props}
        getOrganisationById={this.getOrganisationById}
      />
    );
  }
};

export default withOrganisationData;



/** WEBPACK FOOTER **
 ** ./src/hocs/data/with-organisation-data/index.js
 **/